export default __webpack_public_path__ + "static/media/60.2b8db69a.svg";